<template>
    <!-- <section class="px-3 sm:px-12 sm:mt-12 mb-12"> -->
    <a :name="cat" :id="cat"></a>
    <SubTitle v-if="integration" :title="`Unified API for ${MAP_CATS[cat]} for ${integration.name}`" :small="true" />
    <SubTitle v-if="!integration" :title="`Unified API for ${MAP_CATS[cat]}`" :small="true" />

    <div class="flex flex-wrap items-start">
        <div class="w-full sm:w-2/3 sm:pr-10">
            <p v-html="desc" class="mb-8"></p>
            <div class="flex items-center justify-start flex-wrap gap-2 mb-8" v-if="!noLogos">
                <div v-for="int in INTEGRATIONS" v-show="int.categories?.includes(cat)">
                    <a :href="`/integrations/${int.type}`">
                        <img class="w-10 h-10 object-contain" :title="int.name" :src="int.logo_url" @error="onLogoError" />
                    </a>
                </div>
            </div>
            <div class="mb-8" v-if="!noLogos">
                <a class="btn btn-primary" :href="`/${cat}`"> Learn More </a>
            </div>
            <div v-if="noLogos">
                <a class="btn btn-primary mb-8 w-full sm:w-auto text-center sm:text-left" href="/integrations"> See all
                    integrations </a>
            </div>
        </div>
        <div class="w-full sm:w-1/3 overflow-hidden">
            <pre class="shadow-md p-6 text-primary-green font-semibold" v-html="code"></pre>
        </div>
    </div>
    <!-- </section> -->
</template>

<script lang="ts">
import { onLogoError } from '~/composables/useLogoFallback';
import { type PropType } from 'vue';
import { type IIntegration } from '~~/models/Unified';
import { INTEGRATIONS } from '~~/services/integrations';
import { MAP_CATS } from '~~/services/categories';

export default {
    methods: { onLogoError },
    props: {
        cat: {
            type: String as PropType<keyof typeof MAP_CATS>,
            required: true,
        },
        desc: String,
        code: String,
        noLogos: Boolean,
        integration: Object as PropType<IIntegration>,
    },
    data() {
        return {
            MAP_CATS,
            INTEGRATIONS,
        };
    },
};
</script>

<style scoped>
pre {
    font-size: 14px;
    font-family: 'Courier New', Courier, monospace;
    background-color: #222;
    background: linear-gradient(0deg, #222, #111);
    border-radius: 8px;
    overflow-x: hidden;
    width: 100%;
}
</style>